import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

axios.defaults.baseURL = process.env.VUE_APP_API_URL || 'http://localhost:3000'
axios.defaults.headers = {
  'Content-Type': 'application/json',
  'Authorization': 'Bearer ' + localStorage.token
}

axios.interceptors.response.use(response => response, function(error){
  if (error.response && error.response.status === 401) {
    localStorage.removeItem('token')
    if (window.location.href.indexOf('login') < 0) {
      window.location.href = '/login'
    }
  } else {
    throw error
  }
})

export default axios

Vue.use(VueAxios, axios)
